import type { SVGProps } from 'react';

export const Add = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='currentColor' width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M18 11h-5V6a1 1 0 1 0-2 0v5H6a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2' fillRule='evenodd' />
    </svg>
);
